export default "__VITE_ASSET__DSHwLIG7__"